module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Veltheim_AG-5cc08e565cd912c42c51c4efcc3bd695.svg";